import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.fill.js";
import { toTimeStr } from './toTimeStr';

/**
 * Create an array of selectable times
 *
 * @example
 * [
 * {value: '06:00', label: '06:00 AM'},
 * ...
 * {value: '12:00', label: '12:00 PM'},
 * {value: '12:30', label: '12:30 PM'},
 * {value: '13:30', label: '01:30 PM'},
 * ...
 * {value: '05:30', label: '05:30 AM'}
 * ]
 */

export function getSelectableTimes(userLocale) {
  return Array(24 * 2).fill(1).map(function (a, index) {
    var hour = (index / 2 + 6) % 24;
    var minute = hour % 1 * 60;
    var date = new Date(0, 0, 0, hour, minute);
    var value = toTimeStr(hour, minute);
    var label = new Intl.DateTimeFormat(userLocale, {
      timeStyle: 'short'
    }).format(date);
    return {
      value: value,
      label: label
    };
  });
}
export default getSelectableTimes;